export default __webpack_public_path__ + "static/media/flexik.cdb9c794.svg";